<template>
	<!-- <div @click="updateActivePlan" :class="this.activePlan === this.planName ? 'filling-option active-payment' : 'filling-option'"> -->
	<div :class="this.activePlan === this.planName.letGarburHandleIt ? 'filling-option active-payment' : 'filling-option'">
		<div class="filling-name">
			<div class="plan-name">
				<div class="header5">{{ this.planName }}</div>
				<div v-if="this.isRecommended" class="header6">Recommended</div>
			</div>

			<div class="header3">{{ this.planTitle }}</div>
		</div>
		<div class="filling-price">
			<div class="header1">{{ this.planPrice }}</div>
			<div class="currency">
				{{ this.planName === "Option One" ? "$/Flat Fee" : "$ up-front" }}<br />
				{{ this.planName === "Option Two" ? "Unless we save you money" : "" }}
			</div>
		</div>
		<div class="filling-detail">
			<div v-if="this.planName === 'Option One'" class="option-one-text">
				<div class="paragraph">Provide me the necessary Documents to print and sign, then I will submit to county</div>
				<br />
				<div class="bullet-button-sec">
					<ul class="paragraph">
						<li>Flat Fee</li>
						<li>You control the process</li>
					</ul>
				</div>
			</div>
			<div v-else class="option-two-text">
				<div class="paragraph">
					<p>
						Garbur will mange the entire appeal process on your behalf. All you need to do is sign the appropriate authorization documents
						and we will handle the rest.
						<br />There is on charge unless we save you money.
					</p>
				</div>
				<div class="bullet-button-sec">
					<ul class="paragraph">
						<li>Cost is 1/3 of the first year’s savings</li>
						<li>No savings = No cost</li>
					</ul>
				</div>
			</div>
		</div>
		<div class="icon-cont">
			<div class="icon-sec">
				<!-- <i v-if="this.activePlan === this.planName" class="material-icons">done</i> -->
				<i v-if="this.activePlan === this.planName.letGarburHandleIt" class="material-icons">done</i>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "filling-option",
	props: ["planName", "planTitle", "planPrice", "activePlan", "changePlan", "planDetails", "isRecommended"],
	computed: {
		property() {
			return this.$store.getters.getAllPropertyData;
		},
	},
	mounted() {
		this.changePlan(this.planName.letGarburHandleIt);
	},
	methods: {
		// updateActivePlan() {
		// 	this.changePlan(this.planName);
		// },
		//routes depends on option
		onMyOwn() {
			this.$router.push({ name: "Case" });
		},
		// @TODO ASK do we need to tell them about steps, or where we are saying
		letGarburHandleIt() {
			this.$router.push({ name: "Payment" });
			// @TODO need to ask about caseID and run locally or case.id
			this.$router.push({ name: "Case" });
		},
	},
};
</script>

<style scoped lang="scss">
.filling-option {
	padding: 25px 41px;
	text-align: left;
	background: #ffffff;
	box-shadow: 16px 16px 48px rgba(0, 0, 0, 0.0994678);
	border-radius: 3px;
	height: auto;
	position: relative;
	.filling-name {
		margin-top: 1em;
	}
	.filling-price {
		margin-top: 1.2em;
		margin-bottom: 1em;
		display: flex;
		align-items: baseline;
		.currency {
			font-weight: 600;
			font-size: 16px;
			line-height: 24px;
			color: var(--dark-gray);
		}
	}
	.plan-name {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		.header6 {
			font-size: 11px;
			line-height: 16px;
			color: var(--dark-gray);
		}
		.header5 {
			font-size: 14px;
			line-height: 21px;
			color: var(--dark-gray);
		}
	}
	.filling-detail {
		display: flex;
		.option-two-text {
			margin-top: -18px;
		}
		.bullet-button-sec {
			display: flex;
			flex-direction: row;
			justify-content: space-between;
			align-items: center;
			ul.paragraph {
				padding-left: 20px;
			}
		}
	}
	.icon-cont {
		position: absolute;
		bottom: 35px;
		right: 40px;
	}
	.icon-sec {
		border-radius: 24px;
		display: flex;
		justify-content: center;
		align-items: center;
		text-decoration: none;
		list-style: none;
		width: 48px;
		height: 48px;
		color: var(--accent);
		border: 1px solid var(--accent);
		// transform: scaleX(-1);
	}
	.header3 {
		color: var(--dark-gray);
		font-size: 36px;
		line-height: 36px;
		margin-top: 12px;
	}
	.paragraph {
		color: var(--dark-gray);
		margin-top: 15px;
		opacity: 0.5;
	}
	.header1 {
		color: var(--dark-gray);
		font-weight: 700;
		font-size: 72px;
		line-height: 72px;
	}
}
.active-payment {
	background: var(--dark-blue);
	box-shadow: 16px 16px 48px rgba(0, 0, 0, 0.0994678);
	border-radius: 3px;
	.plan-name .header5,
	.plan-name .header6,
	.header3,
	.header1,
	.filling-price .currency,
	.filling-detail .icon-sec,
	.paragraph {
		color: var(--white);
	}
	.filling-detail .icon-sec {
		border: 1px solid var(--white);
	}
}
@media screen and (max-width: 450px) {
	.filling-option {
		margin-right: unset;
		width: unset;
		height: unset;
	}
}
</style>
